import React from "react";

const LineIcon = ({
  type,
  size = 18,
}) => {

  const commonProps = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };


  switch (type) {

    case "calendar":
      return (
        <svg {...commonProps}>
          <rect
            x="3"
            y="4"
            width="18"
            height="17"
            rx="2"
          />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="9" x2="21" y2="9" />
        </svg>
      );


    case "users":
      return (
        <svg {...commonProps}>
          <path
            d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
          />
          <circle cx="9" cy="7" r="4" />
          <path
            d="M22 21v-2a4 4 0 0 0-3-3.87"
          />
          <path
            d="M16 3.13a4 4 0 0 1 0 7.75"
          />
        </svg>
      );


    case "bed":
      return (
        <svg {...commonProps}>
          <path d="M3 20V9" />
          <path d="M3 17h18v3" />
          <path d="M21 20V13a4 4 0 0 0-4-4H3" />
          <path d="M7 13v-3" />
          <path d="M3 13h18" />
        </svg>
      );


    case "bath":
      return (
        <svg {...commonProps}>
          <path d="M4 12h16" />
          <path d="M5 12v3a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-3" />
          <path d="M6 19v2" />
          <path d="M18 19v2" />
          <path d="M6 12V6a2 2 0 0 1 4 0v1" />
        </svg>
      );


    case "mail":
      return (
        <svg {...commonProps}>
          <rect
            x="3"
            y="5"
            width="18"
            height="14"
            rx="2"
          />
          <path d="m3 7 9 6 9-6" />
        </svg>
      );


    case "phone":
      return (
        <svg {...commonProps}>
          <path
            d="M22 16.92v3a2 2 0 0 1-2.18 2
            19.79 19.79 0 0 1-8.63-3.07
            19.5 19.5 0 0 1-6-6
            19.79 19.79 0 0 1-3.07-8.63
            A2 2 0 0 1 4.11 2h3
            a2 2 0 0 1 2 1.72
            12.84 12.84 0 0 0 .7 2.81
            2 2 0 0 1-.45 2.11L8.09 9.91
            a16 16 0 0 0 6 6l1.27-1.27
            a2 2 0 0 1 2.11-.45
            12.84 12.84 0 0 0 2.81.7
            A2 2 0 0 1 22 16.92z"
          />
        </svg>
      );


    case "check":
      return (
        <svg {...commonProps}>
          <polyline points="20 6 9 17 4 12" />
        </svg>
      );


    case "arrow":
      return (
        <svg {...commonProps}>
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      );


    case "shield":
      return (
        <svg {...commonProps}>
          <path
            d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
          />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      );


    case "info":
      return (
        <svg {...commonProps}>
          <circle cx="12" cy="12" r="9" />
          <line x1="12" y1="10" x2="12" y2="16" />
          <line x1="12" y1="7" x2="12.01" y2="7" />
        </svg>
      );


    case "close":
      return (
        <svg {...commonProps}>
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="18" y1="6" x2="6" y2="18" />
        </svg>
      );


    default:
      return (
        <svg {...commonProps}>
          <circle cx="12" cy="12" r="9" />
        </svg>
      );

  }

};

export default LineIcon;